import { Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { animate, keyframes, state, style, transition, trigger } from '@angular/animations';
import * as kf from '@app/shared/components/keyframes';
import 'hammerjs';
import { MenuProgressStepperComponent } from '@components/menu-progress-stepper/menu-progress-stepper.component';
import { Router } from '@angular/router';
import { EventService } from '@app/shared/helpers/services/event.service';
import { JwtUser } from '@models/authentication/jwt-user.model';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  animations: [
    trigger('expandCollapse', [
      // expandCollapse animation
      state('expanded', style({
        minWidth: '320px'
      })),
      state('collapsed', style({
        minWidth: '80px'
      })),
      transition('expanded <=> collapsed', [
        animate('0.2s ease-in-out')
      ])
    ]),
    trigger('SwipeAnimator', [
      transition('* => swipeLeft', animate(350, keyframes(kf.slideLeft))),
      transition('* => swipeRight', animate(350, keyframes(kf.slideRight)))
    ]),
  ]
})
export class SidenavComponent implements OnInit {
  private static readonly MAX_MOBILE_WIDTH = 960;
  private static readonly maxNumberOfMobileTabs = 4;

  @ViewChild('stepper') stepper: MenuProgressStepperComponent;

  @Input() tabs: any[];
  @Input() allTabs: any[];
  @Input() tabsWithFab;
  @Input() user: JwtUser;

  @Output() isNavbarCollapsed = new EventEmitter<any>();

  tabsToShow = [];

  animationState: string;
  fadeAnimationState: string;

  drawerExpanded: boolean;
  isLastRow: boolean;

  isMobile = false;
  tabsIndex = 0;
  menuIndex: number;
  menuSteps: number;
  innerWidth;

  constructor(private router: Router, private eventService: EventService) {
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = event.target.innerWidth;
    if (this.isMobileResolution()) {
      this.initMobileResolutionLayout();
    } else {
      this.isMobile = false;
    }
  }

  ngOnInit(): void {
    this.drawerExpanded = localStorage.getItem('isNavbarCollapsed') !== 'true';

    if (this.isMobileResolution()) {
      this.initMobileResolutionLayout();
    }
    this.menuIndex = 0;
  }

  initMobileResolutionLayout() {
    this.tabsToShow = [];
    this.menuSteps = this.tabs.length % SidenavComponent.maxNumberOfMobileTabs === 0 ?
      this.tabs.length / SidenavComponent.maxNumberOfMobileTabs :
      Math.floor(this.tabs.length / SidenavComponent.maxNumberOfMobileTabs) + 1;
    if (this.isMobileResolution()) {
      for (let i = 0; i < SidenavComponent.maxNumberOfMobileTabs; i++) {
        this.tabsToShow.unshift(this.tabs[i]);
      }
      this.tabsToShow.reverse();
    } else {
      this.tabsToShow = this.tabs;
    }
    this.isMobile = true;
  }

  toggleDrawer() {
    if (this.isMobile) {
      return;
    }
    this.drawerExpanded = !this.drawerExpanded;
    this.isNavbarCollapsed.emit(!this.drawerExpanded);
  }

  startAnimation(animationState: string) {
    if (this.isMobileResolution()) {
      if (!this.animationState) {
        if (animationState === 'swipeRight' && this.tabsIndex > 0) {
          this.animationState = animationState;
          this.eventService.emitSwipeEvent(this.animationState);
          this.menuIndex--;
          this.stepper.setLine(this.menuIndex);
          this.tabsIndex--;
          this.tabsToShow = [];
          for (let i = this.tabsIndex * SidenavComponent.maxNumberOfMobileTabs;
               i < this.tabsIndex * SidenavComponent.maxNumberOfMobileTabs + SidenavComponent.maxNumberOfMobileTabs;
               i++) {
            this.tabsToShow.unshift(this.tabs[i]);
          }
          this.tabsToShow.reverse();
          this.isLastRow = false;
        } else if (animationState === 'swipeLeft' && !this.isLastRow) {
          this.animationState = animationState;
          this.eventService.emitSwipeEvent(this.animationState);
          this.menuIndex++;
          this.tabsIndex++;
          this.stepper.setLine(this.menuIndex);
          this.tabsToShow = [];
          let finalIndex = this.tabsIndex * SidenavComponent.maxNumberOfMobileTabs + SidenavComponent.maxNumberOfMobileTabs;
          if (finalIndex >= this.tabs.length) {
            this.isLastRow = true;
            finalIndex = this.tabs.length;
          }
          for (let i = this.tabsIndex * SidenavComponent.maxNumberOfMobileTabs; i < finalIndex; i++) {
            this.tabsToShow.unshift(this.tabs[i]);
          }
          this.tabsToShow.reverse();
        }
      }
    }
  }

  resetAnimationState() {
    this.animationState = '';
  }

  isMobileResolution() {
    if (this.innerWidth) {
      return this.innerWidth <= SidenavComponent.MAX_MOBILE_WIDTH;
    } else {
      return window.innerWidth <= SidenavComponent.MAX_MOBILE_WIDTH;
    }
  }

  getLeftIcons() {
    if (this.tabsToShow.length === 1 || this.tabsToShow.length === 2) {
      return [this.tabsToShow[0]];
    }
    if (this.tabsToShow.length > 0) {
      return [this.tabsToShow[0], this.tabsToShow[1]];
    } else {
      return [];
    }
  }

  getRightIcons() {
    if (this.tabsToShow.length === 2) {
      return [this.tabsToShow[1]];
    }
    if (this.tabsToShow.length === 3) {
      return [this.tabsToShow[2]];
    }
    if (this.tabsToShow.length > 0) {
      return [this.tabsToShow[2], this.tabsToShow[3]];
    } else {
      return [];
    }
  }

  hasFab() {
    for (const item of this.tabsWithFab) {
      if (this.router.url.endsWith(item)) {
        return true;
      }
    }
    return false;
  }


}
